import React from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { Button } from "@/components/ui/button";

const Error404 = () => {
  const route = all_routes;
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-background p-4 text-center">
      <div className="max-w-md">
        <div className="mb-8">
          <ImageWithBasePath
            src="assets/img/authentication/error-404.png"
            className="mx-auto w-full max-w-[300px]"
            alt="404 Error"
          />
        </div>
        <h3 className="mb-4 text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
          Oops, something went wrong
        </h3>
        <p className="mb-8 text-muted-foreground">
          Error 404 Page not found. Sorry the page you looking for doesn’t exist
          or has been moved
        </p>
        <Button asChild size="lg">
          <Link to={route.dashboard}>Back to Dashboard</Link>
        </Button>
      </div>
    </div>
  );
};

export default Error404;
